import { observer } from 'mobx-react-lite';
import { FaCalendarAlt } from 'react-icons/fa';

const SessionsDropDownItem = observer(({session, active, handleClick}) => {

return (
    <>
        <div
            key={session.session_id}
            style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'left',
            cursor: 'pointer',
            padding: '10px 10px',
            borderRadius: 5,
            border: active ? '2px solid #229' : '1px solid #ddd',
            background: active ? '#e4e9fa' : '#fafafa'
        }}
        onClick={handleClick}
        >
        <div style={{ color: '#3870b9', fontWeight: 600, fontSize: 14, width: '300px' }}>{session.group_name}</div>
        <div style={{ fontSize: 12, color: '#666', marginTop: 4, width: '200px', textAlign: 'right' }}>
            <FaCalendarAlt color="#666" /> {session.start_date} &mdash; {session.end_date}
            </div>
        </div>
    </>);
});


export default SessionsDropDownItem;